<template>
    <div id="footpage">
        <div class="footpage">
            <div class="" style="padding: 0.4rem 0.3rem;">
                <div class="flx jcfe fdc">
                    <div style="font-size: 0.48rem;" class="clf">{{data_list.web_page_desc}}</div>
                    <div style="margin-top: 0.2rem;">
                        <router-link style="text-decoration: none; font-size: 0.34rem;" class="clf" :to="{ path: '/index10', query: { name: '加入我们' }}">联系我们</router-link>
                        <router-link style="text-decoration: none; font-size: 0.34rem; margin-left: 0.5rem;" class="clf" :to="{ path: '/index7', query: { name: '关于我们' }}">关于我们</router-link>
                    </div>
                    <div class="clf">
                        <span style="color: #fff; font-size: 0.34rem;">友情链接：</span>
                        <div style="font-size: 0.34rem;">
                            <div @click="aassdd(item.link_url)" style="margin-top: 0.4rem;" v-for="(item, index) in data_list.yqlj" :key="index">{{item.link_name}}</div>
                        </div>
                    </div>
                    <div style="margin-top: 0.8rem;">
                        <div class="clf flx aic">
                            <img src="https://www.zhidoudou.com.cn/assets/front/imgs/police.png" alt="" style="width: 0.4rem; height: 0.4rem;">
                            <span style="font-size: 0.34rem; margin-left: 0.1rem;" @click="aassdd('//www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011202008151')">沪公网安备 31011202008151号</span>
                        </div>

                        <div class="clf" style="margin-top: 0.4rem; font-size: 0.34rem;" @click="aassdd('//beian.miit.gov.cn/#/Integrated/index')">沪ICP备2022032374号-1</div>

                        <div class="clf" style="margin-top: 0.4rem; font-size: 0.34rem; line-height: 0.5rem;">上海上通优选农业科技发展有限公司 版权所有 jiaonongyipin.cn</div>

                    </div>
                </div>
            </div>
        </div>
        <div class="flx jcc">
            <img src="../../assets/liangzhan.png" style="width: 1.7rem;height: 1.7rem; margin-top: 0.2rem; margin-bottom: 0.2rem;" alt="" @click="aassdd('https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=91310118MABRXD7G2Q-SAIC_SHOW_10000091310118MABRXD7G2Q1708665054288&signData=MEYCIQCbHKj6xpDXzL6+kHND6yIjU/nFr92CAulxkDojLlRB2gIhALdoGli+z3Iqe+Y6FYRtP4y7wTsjbuLnT4AJXVIfepKw')" class="shouxing"></img>
        </div>
    </div>
</template>

<script>

export default {
    name: 'FootPage',
    data () {
        return {
            data_list: ''
        }
    },
    methods:{
        getData() {
            this.$post('index.php?s=/api/index/pub_api', {
                wxapp_id: 10001
            })
            .then((res) => {
                if(res.code == 1) {
                    this.data_list = res.data.list;
                }
            }) 
        },
        aassdd(e) {
            window.open(e)
        }
    },
    created() {
        this.getData();
    }
}
</script>

<style scoped>
    .footpage{
        background-color: #282828;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/partialset/footpage2.vue